import { PlusIcon, XMarkIcon } from '@heroicons/react/24/outline/index.js';
import TimeOfDayInput from './TimeOfDayInput.jsx';
import { parseTime, ShortDaysOfWeek } from '../../lib/DateTime.js';
import InfoMessageBlock from '~/components/InfoMessageBlock';

const HoursInput = ({ hours, setHours, rightBtnContent }) => {
    function updateHours(idx, when, newValue) {
        const newHours = [...hours];
        newHours[idx][when] = newValue;
        setHours(newHours);
    }

    function isInvalidRange(hoursSet) {
        if (!hoursSet.start || !hoursSet.end) {
            return false;
        }

        const start = parseTime(hoursSet.start);
        const end = parseTime(hoursSet.end);

        return start >= end;
    }

    function isRangeOverlapping(hoursSet, otherHoursSets) {
        if (isInvalidRange(hoursSet)) {
            return false;
        }

        const rangeStart = parseTime(hoursSet.start);
        const rangeEnd = parseTime(hoursSet.end);

        for (const hours of otherHoursSets) {
            const start = parseTime(hours.start);
            const end = parseTime(hours.end);

            if (start < rangeEnd && end > rangeStart) {
                return true;
            }
        }

        return false;
    }

    return (
        <div className="flex justify-between">
            <div>
                {hours.map((hoursSet, idx) => (
                    <div key={idx}>
                        <div
                            className={`flex items-center ${idx > 0 && 'mt-2'}`}
                        >
                            <TimeOfDayInput
                                value={hoursSet.start}
                                //maxValue={hoursSet.end}
                                onChange={newValue =>
                                    updateHours(idx, 'start', newValue)
                                }
                            />
                            <span className="px-1">-</span>
                            <TimeOfDayInput
                                value={hoursSet.end}
                                minValue={hoursSet.start}
                                onChange={newValue =>
                                    updateHours(idx, 'end', newValue)
                                }
                            />
                            <button
                                type="button"
                                onClick={() => {
                                    const newHours = [...hours];
                                    newHours.splice(idx, 1);
                                    setHours(newHours);
                                }}
                            >
                                <XMarkIcon className="ml-2 w-5 h-5 text-block hover:text-primary-700" />
                            </button>
                        </div>
                        {isInvalidRange(hoursSet) && (
                            <InfoMessageBlock
                                className="py-1.5 mt-1"
                                showIcon={true}
                            >
                                The end time spans to the next day
                            </InfoMessageBlock>
                        )}
                        {idx > 0 &&
                            isRangeOverlapping(
                                hoursSet,
                                hours.slice(0, idx),
                            ) && (
                                <div className="text-red-600">
                                    This overlaps another time range
                                </div>
                            )}
                    </div>
                ))}
                {hours.length === 0 && (
                    <div className="text-gray-500 mt-2">Unavailable</div>
                )}
            </div>
            <div className="flex items-end">
                <PlusIcon
                    className="w-5 h-5 text-black hover:text-primary-700 mb-2 cursor-pointer"
                    onClick={() => setHours([...hours, { start: '', end: '' }])}
                />
                {rightBtnContent}
            </div>
        </div>
    );
};

export default HoursInput;
